import { render } from "./IssuedRequestTab.vue?vue&type=template&id=700de284&scoped=true"
import script from "./IssuedRequestTab.vue?vue&type=script&lang=js"
export * from "./IssuedRequestTab.vue?vue&type=script&lang=js"

import "./IssuedRequestTab.vue?vue&type=style&index=0&id=700de284&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700de284"]])

export default __exports__